//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the ProcessTemplatesAfterBuild executable.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
(function () {
    "use strict";

    angular.module("app").factory("installationCertificate", InstallationCertificateFactory);

    InstallationCertificateFactory.$inject = ["apiClientFactory"];
    function InstallationCertificateFactory(apiClientFactory) {

        const routePrefix = "api/Installation/Certificate/";

        return {
            Download: apiClientFactory.getFile(routePrefix + "Download/"),
            Search: apiClientFactory.post(routePrefix + "Search/"),
        };
    }
})();
